import { render } from "./EventBrand.vue?vue&type=template&id=4bb86d84"
import script from "./EventBrand.vue?vue&type=script&lang=js"
export * from "./EventBrand.vue?vue&type=script&lang=js"

import "./EventBrand.vue?vue&type=style&index=0&id=4bb86d84&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__